import { CsvImportDialog } from "@crm-src/components/csv-import-dialog"
import { ContactListsAPI, type ContactList } from "@crm-src/lib/contact-lists-api"

interface ImportContactsDialogProps {
  isOpen: boolean
  onClose: () => void
  selectedGroup: ContactList | null
  onImportComplete: () => void
}

export function ImportContactsDialog({
  isOpen,
  onClose,
  selectedGroup,
  onImportComplete,
}: ImportContactsDialogProps) {
  if (!selectedGroup) return null

  return (
    <CsvImportDialog
      isOpen={isOpen}
      onClose={onClose}
      entityDisplayName={`Contacts to "${selectedGroup.name}"`}
      apiService={{
        import: (data: any[]) => ContactListsAPI.import(selectedGroup.id, data),
      }}
      onImportComplete={onImportComplete}
    />
  )
}
